/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React, { useState, useEffect } from 'react';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Button from '@deprecated-ui/common/Button';
import Input from '@deprecated-ui/common/Input';
import color from '@deprecated-ui/_style/color';
import { useDispatch, useSelector } from 'react-redux';
import { IRulesNewScreener } from 'features/screener/types';
import screenerActions, {
  screenerEffects,
  screenerSelectors,
} from 'features/screener/slice';
import numberUtils from 'utils/number';
import handleErrorMessageAPI from 'global/AlertErrorMessage';
import ERROR_MESSAGE from 'constants/errorMessage';
import styled from 'styled-components';
import ScreenerRules from './ScreenerRules';
import ScreenerStocks from './ScreenerStocks';
import { ScreenerLoadingOverlay } from '../styled';

const { TextArea } = Input;
const { getRandomInt } = numberUtils;

const SInput = styled(Input)`
  border: none;
  .ant-input-group-addon {
    background: ${color.whisper};
  }
  .ant-input:hover,
  .ant-input:focus,
  .ant-input-focused {
    border-color: #d9d9d9;
    box-shadow: none;
  }
`;

const createSequence = (rules: IRulesNewScreener[]) => {
  const sequenceList = [];
  rules.forEach(({ type, item1, item2 }) => {
    const nItem1 = Number(item1);
    const nItem2 = Number(item2);

    if (sequenceList.indexOf(nItem1) < 0) sequenceList.push(nItem1);
    if (type !== 'basic' && sequenceList.indexOf(nItem2) < 0) {
      sequenceList.push(nItem2);
    }
  });
  return sequenceList.join();
};

const ScreenerForm = () => {
  const {
    screenerUtils: { isFormEditMode, isFormCreateMode, screenerAction },
    screenerResult: { data: screenerResultData },
  } = useSelector(screenerSelectors);

  const { postScreener, getScreenerCustom, getScreenerFavorites } =
    screenerEffects;

  const [form, setForm] = useState<any>({
    name: '',
    description: '',
    save: '1',
    ordertype: 'asc',
    ordercol: 2, // default: 2 hardcode from legacy x
    page: 1,
    universe: {
      scope: 'IHSG',
      scopeID: '',
      name: '',
    },
    filters: [
      {
        type: 'basic',
        item1: null,
        item1name: '',
        operator: '>',
        item2: null,
        multiplier: '',
      },
    ],
    sequence: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const onInputForm = (field: string, value) => {
    setForm((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const onSelectUniverse = (scope: string, scopeID: string) => {
    setForm((prevState) => ({
      ...prevState,
      universe: {
        ...prevState.universe,
        scope,
        scopeID,
      },
    }));
  };

  const onChangeRules = (rules) => {
    if (rules !== form.filters) {
      const sequences = createSequence(rules);
      setForm((prevState) => ({
        ...prevState,
        filters: rules,
        sequence: sequences,
        save: '1',
      }));
      if (rules.length === 0) {
        dispatch(
          screenerActions.actions.updateScreenerResult({
            screenerAction,
            screener: {
              rules,
            },
          }),
        );
      }
    }
  };

  const resetState = () => {
    setForm({
      name: '',
      description: '',
      save: '1',
      ordertype: 'asc',
      ordercol: 2,
      page: 1,
      universe: {
        scope: 'IHSG',
        scopeID: '',
        name: '',
      },
      filters: [
        {
          type: 'basic',
          item1: null,
          item1name: '',
          operator: '>',
          item2: null,
          multiplier: '',
        },
      ],
      sequence: '',
    });
  };

  const validateFormScreener = (func: () => void) => {
    if (form.filters.length === 0) {
      handleErrorMessageAPI(
        ERROR_MESSAGE.SCREENER_SPECIFY_RULES,
        ERROR_MESSAGE.ALERT_RED,
      );
      return;
    }
    return func();
  };

  const parseScreenerRules = (rules) => {
    const updatedRules = rules.map((rule) => {
      const item2 = rule.item1 !== '' ? rule.item2 : '';
      return {
        ...rule,
        item2: rule.item2 ? item2 : 0,
      };
    });
    return updatedRules;
  };

  const onSaveScreener = () =>
    validateFormScreener(() => {
      setIsLoading(true);
      const randomName = `TEMPLATE_BUILD_${getRandomInt(
        1,
        9999,
      )}_${getRandomInt(1, 9999)}`;
      let screenerName = form.name;
      if (!form?.screenerid && !screenerName) screenerName = randomName;

      const parsedScreenerRules = parseScreenerRules(form.filters);
      const correctForm = {
        ...form,
        name: screenerName,
        universe: JSON.stringify(form.universe),
        filters: JSON.stringify(parsedScreenerRules),
        screenerid: form?.screenerid?.toString() || undefined,
        fromForm: true,
      };

      setForm((prev) => ({
        ...prev,
        filters: parsedScreenerRules,
      }));
      onInputForm('name', screenerName);

      // @ts-ignore
      dispatch(postScreener(correctForm)).then(() => {
        dispatch(getScreenerCustom());
        dispatch(getScreenerFavorites());
        setIsLoading(false);
      });
    });

  const onRunScreener = () =>
    validateFormScreener(() => {
      const randomName = `TEMPLATE_BUILD_${getRandomInt(
        1,
        9999,
      )}_${getRandomInt(1, 9999)}`;
      const screenerName = form.name !== '' ? form.name : randomName;
      const parsedScreenerRules = parseScreenerRules(form.filters);
      const correctForm = {
        ...form,
        screenerid: '0',
        name: screenerName,
        save: '0',
        universe: JSON.stringify(form.universe),
        filters: JSON.stringify(parsedScreenerRules),
        type: 'TEMPLATE_TYPE_CUSTOM',
        fromForm: true,
      };

      setForm((prev) => ({
        ...prev,
        filters: parsedScreenerRules,
      }));

      onInputForm('name', screenerName);
      dispatch(postScreener(correctForm));
    });

  const convertRules = (rules) => {
    const convertedRules = [];
    rules.map((rule) => {
      convertedRules.push({
        type: rule.type,
        item1: rule.item1,
        item1name: rule.item1_name,
        operator: rule.operator,
        item2: rule.item2,
        item2name: rule.item2_name,
        multiplier: rule.multiplier,
      });
    });
    return convertedRules;
  };

  const initValueFormEdit = (
    screenName,
    screenDesc,
    sort,
    order,
    universe,
    sequence,
    rules,
    screenerid,
    isguru,
  ) => {
    const parsedUniverse = JSON.parse(universe);
    setForm((prevState) => ({
      ...prevState,
      name: screenName,
      description: screenDesc,
      ordertype: sort,
      ordercol: order,
      universe: {
        ...prevState.universe,
        scope: parsedUniverse.scope,
        scopeID: parsedUniverse.scopeID,
        name: parsedUniverse.name,
      },
      sequence: sequence.join(),
      filters: convertRules(rules),
      screenerid: isguru ? '0' : screenerid,
    }));
  };

  useEffect(() => {
    const {
      screen_name: screenName,
      screen_desc: screenDesc,
      sort,
      order,
      universe,
      sequence,
      rules,
      screenerid,
      isguru,
    } = screenerResultData;
    if (isFormEditMode) {
      initValueFormEdit(
        screenName,
        screenDesc,
        sort,
        order,
        universe,
        sequence,
        rules,
        screenerid,
        isguru,
      );
    }
  }, [screenerResultData]);

  useEffect(() => {
    if (isFormCreateMode) {
      resetState();
    }
  }, [isFormCreateMode]);

  const { name, description, universe, filters } = form;

  return (
    <>
      <ScreenerLoadingOverlay isLoading={isLoading} />
      {/* @ts-expect-error */}
      <Flex justify="space-between" width="100%" mb="15px">
        <SInput
          key="input"
          width="calc(100% - 130px)"
          // prettier-ignore
          addonBefore={(
            <Text color={color.highempahis} weight="700" family="bold">
              Screen Name
            </Text>
          )}
          name="screenName"
          // @ts-expect-error
          mr="12px"
          onChange={(e) => {
            onInputForm('name', e.target.value);
          }}
          defaultValue={name}
          value={name}
        />
        {/* @ts-expect-error */}
        <Button type="primary" p="4px 10px" onClick={onSaveScreener}>
          Save Screener
        </Button>
      </Flex>
      {/* @ts-expect-error */}
      <Flex direction="column" mb="15px" width="100%" as="h3">
        <Text color={color.dimgray} weight="700" family="bold">
          Description
        </Text>
        <TextArea
          // @ts-expect-error
          mt="10px"
          name="description"
          rows={1}
          autoSize
          onChange={(e) => {
            onInputForm('description', e.target.value);
          }}
          defaultValue={description}
          value={description}
        />
      </Flex>
      <ScreenerStocks
        defaultValue={universe}
        onSelectUniverse={onSelectUniverse}
      />
      <ScreenerRules
        defaultValue={filters}
        onChangeRules={onChangeRules}
        onRunScreener={onRunScreener}
      />
    </>
  );
};

// I've test this memo, and its necessary
export default React.memo(ScreenerForm);
